/**
 * 클립보드 복사 + 토스트 컨트롤러.
 *
 * [data-fw-copy] 버튼 클릭 시 data-copy-text (폴백: data-account) 값을 clipboard 로 복사하고
 * 하단 중앙에 "복사되었습니다." 토스트 표시. navigator.clipboard 미지원 환경은 textarea + execCommand fallback.
 *
 * 토스트 DOM (#__fwCopyToast) 은 컨트롤러가 최초 1회 동적 생성. 디자이너가 별도 CSS 불필요.
 */
export const COPY_TOAST_CONTROLLER_SCRIPT = `
<script data-fw-copy-toast-controller>
(function () {
  var toastTimer = null;
  function ensureToast() {
    var t = document.getElementById('__fwCopyToast');
    if (!t) {
      t = document.createElement('div');
      t.id = '__fwCopyToast';
      t.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:rgba(0,0,0,0.85);color:#fff;padding:12px 20px;border-radius:8px;font-size:14px;z-index:9999;opacity:0;transition:opacity .2s;pointer-events:none;';
      document.body.appendChild(t);
    }
    return t;
  }
  function showToast(msg) {
    var t = ensureToast();
    t.textContent = msg || '복사되었습니다.';
    t.style.opacity = '1';
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.style.opacity = '0'; }, 1800);
  }
  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); showToast(); } catch (e) { /* silent */ }
    document.body.removeChild(ta);
  }
  function doCopy(text) {
    if (!text) return;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(function () { showToast(); }).catch(function () { fallbackCopy(text); });
    } else {
      fallbackCopy(text);
    }
  }
  function init() {
    var btns = document.querySelectorAll('[data-fw-copy]');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      if (btn.dataset.fwCopyInit) continue;
      btn.dataset.fwCopyInit = '1';
      btn.addEventListener('click', (function (b) {
        return function (e) {
          e.preventDefault();
          var text = b.getAttribute('data-copy-text') || b.getAttribute('data-account') || '';
          doCopy(text);
        };
      })(btn));
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
</script>
`;
//# sourceMappingURL=copy-toast.js.map